import React, {Component} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Builder} from "../../../utils/lists/ListProcessor";
import {MaintenanceDomainsService} from "../../../service/maintenance/domains/MaintenanceDomainsService";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {Growl} from "primereact/growl";
import MaintenanceDomainsView from "./MaintenanceDomainsView";
import {Button} from "primereact/button";

export default class MaintenanceDomainsContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.maintenanceDomainsService = new MaintenanceDomainsService();
        this.getDataDomains = this.getDataDomains.bind(this);

        this.state = {
            isInterno: localStorage.getItem('institution') === 'Interno',
            dataDomains: this.getDataDomains(),
            isLoading: false,
            expanded: false,
            domainData: {},
        };
        this.maintDomainsActionTemplate = this.maintDomainsActionTemplate.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.addDomain = this.addDomain.bind(this);
        this.saveDomain = this.saveDomain.bind(this);
        this.deleteDomain = this.deleteDomain.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeDropDown = this.onChangeDropDown.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    /**
     * Función que hace una consulta al back para obtener la lista de
     * las posiciones y colocar la lista en la tabla de la pantalla
     * principal
     */
    getDataDomains() {
        this.loading(true);
        this.maintenanceDomainsService.getDataDomains()
            .then((resp) => {
                let builder = new Builder();
                builder.groupList(resp, 'nomCorto');
                this.setState({
                    dataDomains: builder.mapObjects,
                    isLoading: false,
                });
            });
    }

    /**
     * Función que maneja qué fila fue seleccionada para expandirla
     * y mostrar la lista de cuentas que contiene.
     * @param event Evento que trae la información de la opción expandida.
     */
    handleToggle = (event) => {
        this.setState(
            {
                expandedRows: event.data,
            })
    };

    /**
     * Función que maneja la selección de una fila pero esta vez es de la opción
     * que se seleccionó en la lista dentro se las cuentas para editarla o
     * eliminarla
     * @param event Evento que trae la información de la opción seleccionada.
     */
    handleSelectedRow = (event) => {
        this.setState(
            {
                selectedPosition: event.value,
            })
    }

    /**
     * Función que realiza un template de las listas que se contienen en las emisoras
     * Realiza una tabla donde las muestra.
     * @param data Información de la lista contenida en cada renglón principal.
     * @returns {*} Template para cada una de las cuentas
     */
    rowExpansionTemplate(data) {
        const itemsInstitution = data.items;
        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    value={itemsInstitution}
                    responsive={true}
                    selectionMode="single"
                    onSelectionChange={this.handleSelectedRow.bind(this)}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>

                    <Column field="dominio" header="Dominio" style={{textAlign: 'left'}} sortable={true}/>
                    <Column header="Acciones"
                            body={this.maintDomainsActionTemplate}
                            style={{textAlign: 'center', width: '8em'}}/>
                </DataTable>
            </div>
        );
    }

    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    maintDomainsActionTemplate(rowData, column) {
        return (
            <ConfirmationMessage nameButton="Eliminar"
                                 className="p-button-secondary"
                                 legend="¿Está seguro que desea eliminar el registro?"
                                 action={() => this.deleteDomain(rowData)}
            />
        );
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    addDomain() {
        let domainDataAux = {};
        domainDataAux['domain'] = '';
        domainDataAux['idInstitucion'] = null;
        domainDataAux['instObj'] = '';
        domainDataAux['nombreCorto'] = this.state.isInterno ? '' :
            localStorage.getItem('institution');
        this.setState({
            domainData: domainDataAux,
            displayDialog: true,
        });
    }

    /**
     * Función que toma la posición seleccionada y la elimina de la tabla.
     * Para ello hace una petición al servicio CaptureGuaranteesService
     */
    deleteDomain(rowData) {
        this.loading(true);
        this.maintenanceDomainsService.deleteDomain(rowData)
            .then(res => {
                this.setState({dataDomains: this.getDataDomains(),});
                this.growl.show({
                    severity: 'success', summary: 'Éxito.',
                    detail: 'Datos eliminados correctamente.'
                });
            });
        this.loading(false);
    }

    /**
     * Función que se encarga de contraer y expandir los grupos de
     * instituciones en el dataTable
     */
    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.dataDomains,
                expanded: true,
            });
        }
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    saveDomain() {
        let keyfilter = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        this.loading(true);
        if (this.state.domainData.nombreCorto !== '' && this.state.domainData.domain.match(keyfilter)) {
            this.maintenanceDomainsService.insertDomain(this.state.domainData)
                .then(res => {
                    this.setState({
                        dataDomains: this.getDataDomains(),
                        displayDialog: false,
                    });
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'Datos guardados correctamente.'
                    });
                });
        } else {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Llenar correctamente los campos requeridos'
            });
        }
        this.loading(false);
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeText(event) {
        const {name, value} = event.target;
        let domainDataAux = this.state.domainData;
        domainDataAux[name] = value;
        this.setState({domainData: domainDataAux,})
    }

    /**
     * Función que maneja el cambio en el dropdown de cuenta
     * se guarda la opción elegida en una variable del estado
     * @param event Evento que trae el valor que se eligió.
     */
    onChangeDropDown(event) {
        let {name, value} = event.target;
        value = value ? value : '';
        let domainDataAux = this.state.domainData;
        domainDataAux[name] = value;
        domainDataAux['nombreCorto'] = value['nombreCorto'];
        domainDataAux['idInstitucion'] = value['idInstitucion'];
        this.setState({domainData: domainDataAux,})
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Agregar Dominio</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-3" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.saveDomain}/>
                </div>
            </div>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataDomains, expandedRows, isLoading, displayDialog,
            domainData, isInterno
        } = this.state;
        return (
            <MaintenanceDomainsView dataDomains={dataDomains}
                                    expandedRows={expandedRows}
                                    isLoading={isLoading}
                                    messagesGrowl={messagesGrowl}
                                    dialogHeader={dialogHeader}
                                    displayDialog={displayDialog}
                                    domainData={domainData}
                                    isInterno={isInterno}
                                    loading={this.loading}
                                    addDomain={this.addDomain}
                                    handleToggle={this.handleToggle}
                                    rowExpansionTemplate={this.rowExpansionTemplate}
                                    expandReduceAll={this.expandReduceAll}
                                    getDataDomains={this.getDataDomains}
                                    onHideDialog={this.onHideDialog}
                                    onChangeText={this.onChangeText}
                                    onChangeDropDown={this.onChangeDropDown}
            />
        );
    }
}
